import { t } from '../../../locales';
import { featureFlag } from '../../entities/feature-flag';

const ziebartAgentRoutes = {
	path: 'ziebart',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: featureFlag.CAR_CARE,
		// TODO:
	},
	children: [
		{
			path: 'ziebart-data',
			component: () => import('./pages/organization-data/index.vue'),
			meta: {
				title: t('ziebart.ziebart-data'),
			},
		},
		{
			path: 'bookings-list',
			component: () => import('./pages/bookings-list/index.vue'),
			meta: {
				title: t('ziebart.bookings-list'),
			},
		},
	],
};

export { ziebartAgentRoutes };
